import request from '@/utils/request'
import URL from '@/api/urlTranslator'

/**
 * 获取特殊操作码列表
 * @returns {AxiosPromise}
 * @param data
 */
export function getSpecialOperationCodeList(data) {
  return request({
    url: URL.mdm.basicData.specialOperationCodeList,
    method: 'POST',
    data
  })
}

/**
 * 新增/编辑特殊操作码
 * @param data
 * @returns {AxiosPromise}
 */
export function saveSpecialOperationCode(data) {
  return request({
    url: URL.mdm.basicData.specialOperationCodeSave,
    method: 'POST',
    data
  })
}

/**
 * 删除特殊操作码
 * @returns {AxiosPromise}
 * @param data
 */
export function delSpecialOperationCode(data) {
  return request({
    url: URL.mdm.basicData.specialOperationCodeDelete,
    method: 'POST',
    data
  })
}

